<template>
    <div class="my-0">
      <v-row>
        <v-col cols="12" md="12">
          <v-card
            flat
            class="border-radius">
            <v-card-text class="py-0">
              <v-tabs
                v-model="tab"
                background-color="transparent"
                color="#240087"
                slider-size="4">
                <v-tabs-slider color="#240087"></v-tabs-slider>
                <v-tab
                  v-for="(item, index) in menu"
                  :key="index"
                  class="text-capitalize">
                  <span class="body-2" :class="tab === index ? 'font-weight-bold color-default' : 'text-third'">
                    {{ item.label }}
                  </span>
                </v-tab>
              </v-tabs>
              <v-divider/>
              <v-tabs-items v-model="tab">
                <v-tab-item
                  v-for="(item, index) in menu"
                  :key="index">
                  <router-view :model="tab"/>
                </v-tab-item>
              </v-tabs-items>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </template>
  
  <script>
    import { TokenService } from "@/service/Storage.Service";
    import { get, post, put, patch, destroy } from "@/service/Axios";
    import moment from "moment"
    import "moment/locale/id"
    export default {
      data () {
        return {
          tab: 0,
          menu: [
            { label: 'Trah', link: '/konfigurasi/trah/data' },
            { label: 'Status Trah', link: '/konfigurasi/trah/status' }
          ],
        }
      },
      components: {
        
      },
      computed: {
      },
      watch: {
        "tab": function(val) {
          this.$router.push({ path: `${this.menu[val].link}` })
        }
      },
      mounted () {
        this.tab = this.menu.findIndex(item => item.link === this.$route.path)
      },
      methods: {
        
      }
    }
  </script>